<script lang="ts">
	import { grow } from '@astlai/common/util/transitions';
	import { getRightPanelContext } from 'src/contexts/right-panel.context.svelte';
	import { resizable } from './resizable.svelte';

	const rightPanelCtx = getRightPanelContext();
</script>

{#if rightPanelCtx.current}
	<div
		transition:grow={{ duration: 200, axis: 'x', reverse: true }}
		class="right-panel"
		{@attach resizable({
			side: 'left',
			minWidth: 200,
			maxWidth: 600,
			storageKey: 'layout.rightPanelWidth'
		})}
	>
		<rightPanelCtx.current.component {...rightPanelCtx.current.props} />
	</div>
{/if}

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.right-panel {
		flex: 1 1 auto;
		overflow: hidden;
		background: var(--surface-1);
		@include lib.flex-column();
		z-index: 3;
		position: absolute;
		left: 0;
		top: 0;
		// because of resizable:
		min-width: 100%;
		max-width: 100%;

		max-height: 100%;
		border-bottom-left-radius: 1.5rem;
		border-bottom-right-radius: 1.5rem;
		border-bottom: 1px solid var(--border-subtle);

		@include lib.bp(gt-xs) {
			max-width: none;
			min-width: 0;
			flex: 0 0 auto;
			position: relative;
			width: 400px;
			border-bottom: none;
			border-radius: 0;
			border-left: 1px solid var(--border-subtle);
		}
	}
</style>
